/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import App from './App.vue';
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router';
import NowUiKit from './plugins/now-ui-kit';

import VueCurrencyFilter from 'vue-currency-filter';
import VueScrollTo from 'vue-scrollto';
import VueMask from 'v-mask';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Hotjar from 'vue-hotjar';

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

import { funcoesTema } from './services/tema';

Vue.config.productionTip = false;
Vue.prototype.$funcoesTema = funcoesTema;
Vue.use(NowUiKit);

import 'vue-event-calendar/dist/style.css'; //^1.1.10, CSS has been extracted as one file, so you can easily update it.
import vueEventCalendar from 'vue-event-calendar';
// locale can be 'zh' , 'en' , 'es', 'pt-br', 'ja', 'ko', 'fr', 'it', 'ru', 'de', 'vi', 'ua', 'no, 'no-nn'
Vue.use(vueEventCalendar, {
  locale: 'pt-br',
});

import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors',
});

Vue.component('v-select', vSelect);

Vue.use(VueScrollTo);

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
});

Vue.use(VueMask);

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

/*
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-171742245-1',
  router,
});*/

import VueGtag from 'vue-gtag-conversion';

Vue.use(VueGtag, {
  id: process.env.VUE_APP_GTM, // Your Adwords ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: process.env.NODE_ENV !== 'production' (optional)
  debug: false, // Whether or not display console log debugs (optional)
});

import GAuth from 'vue-google-oauth2';
Vue.use(GAuth, {
  clientId:
    '887742646479-r7fovp23r3uf6qr1jtf88u1d7ahieuh5.apps.googleusercontent.com',
  scope: 'email',
  prompt: 'consent',
  fetch_basic_profile: true,
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
